// 卡通动漫第一页 · 站点数据
// 作品图片使用统一风格的插画图，保证页面视觉一致

export interface Anime {
  id: number;
  title: string;
  tag: string;
  episodes: string;
  score: string;
  update: string;
  desc: string;
  image: string;
}

export const NAV_LINKS = [
  { id: 'home', label: '首页' },
  { id: 'hot', label: '热门作品' },
  { id: 'category', label: '主题分类' },
  { id: 'new', label: '新番连载' },
  { id: 'guide', label: '追更攻略' },
  { id: 'faq', label: '常见问题' },
  { id: 'about', label: '关于我们' },
  { id: 'contact', label: '联系我们' },
];

export const CATEGORIES = [
  { icon: 'ri-fire-fill', name: '热血冒险', count: 268, color: 'bg-primary-100 text-primary-700', desc: '燃爆的战斗与成长', works: ['海贼王', '咒术回战', '鬼灭之刃', '我的英雄学院', '炎炎消防队'] },
  { icon: 'ri-sword-fill', name: '奇幻异界', count: 213, color: 'bg-accent-100 text-accent-700', desc: '异世界与魔法冒险', works: ['葬送的芙莉莲', '迷宫饭', '无职转生', '来自深渊', '关于我转生成为史莱姆这件事'] },
  { icon: 'ri-heart-3-fill', name: '恋爱日常', count: 197, color: 'bg-secondary-100 text-secondary-700', desc: '甜度满分的日常', works: ['间谍过家家', '堀与宫村', '辉夜大小姐想让我告白', '青春猪头少年', '我心危'] },
  { icon: 'ri-sun-fill', name: '治愈系', count: 156, color: 'bg-primary-100 text-primary-700', desc: '温暖人心的故事', works: ['夏目友人帐', '紫罗兰永恒花园', '摇曳露营', '蜜蜂与远雷', '白箱'] },
  { icon: 'ri-rocket-2-fill', name: '科幻机甲', count: 143, color: 'bg-accent-100 text-accent-700', desc: '未来科技与机甲', works: ['进击的巨人', '机动战士高达', 'EVA', '86不存在的战区', '冥王'] },
  { icon: 'ri-search-eye-fill', name: '悬疑推理', count: 128, color: 'bg-secondary-100 text-secondary-700', desc: '烧脑的谜题解局', works: ['名侦探柯南', '药屋少女的呢喃', '夏日重现', '奇巧计程车', '冰菓'] },
  { icon: 'ri-emotion-laugh-fill', name: '搞笑喜剧', count: 184, color: 'bg-primary-100 text-primary-700', desc: '快乐源泉不间断', works: ['银魂', '间谍过家家', '在下坂本', '日常', '男子高中生的日常'] },
  { icon: 'ri-medal-fill', name: '运动竞技', count: 96, color: 'bg-accent-100 text-accent-700', desc: '热血赛场挥洒汗水', works: ['蓝色监狱', '排球少年', '灌篮高手', '赛马娘', '黑子的篮球'] },
];

export const HOT_WORKS: Anime[] = [
  {
    id: 1,
    title: '海贼王',
    tag: '热血冒险',
    episodes: '连载至1080集',
    score: '9.8',
    update: '每周日更新',
    desc: '路飞与草帽一伙向着伟大航路的终点「拉夫德鲁」扬帆起航，追寻传说中的大秘宝，兄弟情义与热血冒险永不停歇。',
    image: 'https://readdy.ai/api/search-image?query=A%20vibrant%20hand-drawn%20anime%20illustration%20of%20a%20courageous%20young%20pirate%20captain%20with%20a%20straw%20hat%20on%20the%20bow%20of%20a%20sailing%20ship%2C%20ocean%20waves%20and%20golden%20sunset%2C%20energetic%20adventure%20atmosphere%2C%20warm%20coral%20and%20teal%20color%20palette%2C%20clean%20flat%20illustration%20style&width=800&height=1000&seq=hot-anime-01&orientation=portrait',
  },
  {
    id: 2,
    title: '咒术回战',
    tag: '热血战斗',
    episodes: '连载至第2季',
    score: '9.5',
    update: '每周五更新',
    desc: '高中生虎杖悠仁吞下特级咒物后卷入咒术师与咒灵的战斗，在伙伴与使命之间，踏上斩断诅咒的少年热血之路。',
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20hand-drawn%20anime%20illustration%20of%20a%20young%20male%20warrior%20in%20dark%20uniform%20surrounded%20by%20glowing%20energy%20curses%2C%20dramatic%20dark%20city%20background%2C%20powerful%20fighting%20pose%2C%20vibrant%20coral%20and%20teal%20color%20palette%2C%20clean%20flat%20illustration%20style&width=800&height=1000&seq=hot-anime-02&orientation=portrait',
  },
  {
    id: 3,
    title: '鬼灭之刃',
    tag: '热血战斗',
    episodes: '全季完结+剧场版',
    score: '9.7',
    update: '剧场版热映中',
    desc: '少年炭治郎为拯救变成鬼的妹妹祢豆子加入鬼杀队，在一次次生死战斗中斩妖除魔，守护家人的羁绊动人心弦。',
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20hand-drawn%20anime%20illustration%20of%20a%20young%20swordsman%20wearing%20a%20checkered%20pattern%20haori%20holding%20a%20katana%2C%20cherry%20blossoms%20and%20warm%20light%20background%2C%20emotional%20heroic%20atmosphere%2C%20vibrant%20coral%20and%20teal%20color%20palette%2C%20clean%20flat%20illustration%20style&width=800&height=1000&seq=hot-anime-03&orientation=portrait',
  },
  {
    id: 4,
    title: '间谍过家家',
    tag: '搞笑日常',
    episodes: '连载至第2季',
    score: '9.6',
    update: '每周六更新',
    desc: '间谍、杀手与超能力少女组成的「临时家庭」，一边瞒着彼此的秘密，一边笑料百出的温馨日常，让人捧腹又暖心。',
    image: 'https://readdy.ai/api/search-image?query=A%20cute%20hand-drawn%20anime%20illustration%20of%20a%20happy%20family%20with%20a%20spy%20father%2C%20an%20assassin%20mother%20and%20a%20telepathic%20little%20girl%2C%20bright%20playful%20domestic%20background%2C%20warm%20cheerful%20mood%2C%20vibrant%20coral%20and%20teal%20color%20palette%2C%20clean%20flat%20illustration%20style&width=800&height=1000&seq=hot-anime-04&orientation=portrait',
  },
  {
    id: 5,
    title: '葬送的芙莉莲',
    tag: '奇幻治愈',
    episodes: '全季完结',
    score: '9.8',
    update: '已完结',
    desc: '勇者一行击败魔王后的数十年，长寿精灵芙莉莲踏上重新认识人类与朋友的旅程，在时间的流逝中读懂羁绊的意义。',
    image: 'https://readdy.ai/api/search-image?query=A%20gentle%20hand-drawn%20anime%20illustration%20of%20a%20white-haired%20elf%20mage%20in%20flowing%20robes%20walking%20through%20a%20misty%20fantasy%20forest%20with%20soft%20magic%20light%2C%20melancholic%20yet%20warm%20atmosphere%2C%20vibrant%20coral%20and%20teal%20color%20palette%2C%20clean%20flat%20illustration%20style&width=800&height=1000&seq=hot-anime-05&orientation=portrait',
  },
  {
    id: 6,
    title: '进击的巨人',
    tag: '科幻战争',
    episodes: '全季完结',
    score: '9.5',
    update: '已完结',
    desc: '在巨人与人类对峙的残酷世界里，艾伦与调查兵团一次次冲向城墙之外，探寻自由与真相的史诗级旅程震撼人心。',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20hand-drawn%20anime%20illustration%20of%20a%20young%20soldier%20standing%20before%20a%20massive%20stone%20wall%20with%20a%20giant%20titan%20silhouette%20in%20the%20sky%2C%20epic%20gritty%20atmosphere%2C%20vibrant%20coral%20and%20teal%20color%20palette%2C%20clean%20flat%20illustration%20style&width=800&height=1000&seq=hot-anime-06&orientation=portrait',
  },
];

export const NEW_RELEASES = [
  {
    id: 1,
    title: '葬送的芙莉莲',
    season: '秋季新番',
    status: '热播中',
    desc: '勇者一行击败魔王后的数十年，长寿精灵芙莉莲踏上重新认识人类与朋友的旅程。',
    image: 'https://readdy.ai/api/search-image?query=A%20soft%20hand-drawn%20anime%20illustration%20of%20a%20white-haired%20elf%20mage%20in%20white%20robes%20surrounded%20by%20glowing%20fantasy%20flora%2C%20gentle%20warm%20magic%20aura%2C%20vibrant%20coral%20and%20teal%20color%20palette%2C%20clean%20flat%20illustration%20style&width=600&height=760&seq=new-anime-01&orientation=portrait',
  },
  {
    id: 2,
    title: '我推的孩子',
    season: '春季新番',
    status: '更新至11话',
    desc: '当红偶像被卷入意想不到的命运，转生成为偶像之子的少年踏上追寻真相的道路。',
    image: 'https://readdy.ai/api/search-image?query=A%20stylish%20hand-drawn%20anime%20illustration%20of%20a%20young%20man%20with%20diamond%20star%20eyes%20under%20stage%20spotlights%2C%20glittering%20concert%20backdrop%2C%20vibrant%20coral%20and%20teal%20color%20palette%2C%20clean%20flat%20illustration%20style&width=600&height=760&seq=new-anime-02&orientation=portrait',
  },
  {
    id: 3,
    title: '药屋少女的呢喃',
    season: '秋季新番',
    status: '热播中',
    desc: '在后宫任职的少女药师猫猫，凭借敏锐观察力与药学知识，一步步解开宫廷内的谜团。',
    image: 'https://readdy.ai/api/search-image?query=A%20graceful%20hand-drawn%20anime%20illustration%20of%20a%20young%20girl%20in%20elegant%20traditional%20robes%20holding%20herbs%20in%20an%20ancient%20imperial%20palace%20garden%2C%20warm%20oriental%20atmosphere%2C%20vibrant%20coral%20and%20teal%20color%20palette%2C%20clean%20flat%20illustration%20style&width=600&height=760&seq=new-anime-03&orientation=portrait',
  },
  {
    id: 4,
    title: '迷宫饭',
    season: '冬季新番',
    status: '更新至8话',
    desc: '在迷宫深处，冒险小队为生存踏上「吃魔物」的奇妙旅途，美食与冒险交织的脑洞之作。',
    image: 'https://readdy.ai/api/search-image?query=A%20whimsical%20hand-drawn%20anime%20illustration%20of%20adventurers%20cooking%20colorful%20monster%20ingredients%20over%20a%20campfire%20inside%20a%20stone%20dungeon%2C%20playful%20cozy%20mood%2C%20vibrant%20coral%20and%20teal%20color%20palette%2C%20clean%20flat%20illustration%20style&width=600&height=760&seq=new-anime-04&orientation=portrait',
  },
  {
    id: 5,
    title: '赛马娘',
    season: '冬季新番',
    status: '热播中',
    desc: '化身少女赛马们奔向梦想的舞台，在奔跑与汗水间书写青春与竞技的热血物语。',
    image: 'https://readdy.ai/api/search-image?query=A%20energetic%20hand-drawn%20anime%20illustration%20of%20a%20girl%20with%20horse%20ears%20racing%20on%20a%20sunlit%20track%2C%20dynamic%20running%20pose%20with%20speed%20lines%2C%20vibrant%20coral%20and%20teal%20color%20palette%2C%20clean%20flat%20illustration%20style&width=600&height=760&seq=new-anime-05&orientation=portrait',
  },
  {
    id: 6,
    title: '蓝色监狱',
    season: '春季新番',
    status: '更新至12话',
    desc: '为了打造世界最强前锋，300名高中生被关进「蓝色监狱」，在极限对决中脱颖而出。',
    image: 'https://readdy.ai/api/search-image?query=A%20fierce%20hand-drawn%20anime%20illustration%20of%20a%20young%20soccer%20player%20kicking%20a%20ball%20inside%20a%20futuristic%20blue-tinted%20training%20arena%2C%20dramatic%20competitive%20energy%2C%20vibrant%20coral%20and%20teal%20color%20palette%2C%20clean%20flat%20illustration%20style&width=600&height=760&seq=new-anime-06&orientation=portrait',
  },
];

export const GUIDE_STEPS = [
  {
    icon: 'ri-focus-3-line',
    title: '打开即看',
    desc: '进入卡通动漫第一页首页，无需注册登录，热门作品与新番入口一目了然，打开即可直接进入对应页面观看。',
  },
  {
    icon: 'ri-bookmark-line',
    title: '一键收藏',
    desc: '点击浏览器书签或「收藏本站」，把第一页加入收藏夹，以后想看动漫随时一键直达，再也不怕找不到入口。',
  },
  {
    icon: 'ri-slideshow-3-line',
    title: '跟随新番',
    desc: '在「新番连载」板块查看每周更新安排，锁定你追的番剧更新时间，准时守候，不错过任何一集精彩内容。',
  },
  {
    icon: 'ri-send-plane-line',
    title: '推荐 & 反馈',
    desc: '不知道看什么？浏览热门作品与主题分类找灵感；想看的作品找不到，通过「联系我们」告诉我们，帮你完善入口。',
  },
];

export const FAQS = [
  {
    q: '什么是卡通动漫第一页？',
    a: '卡通动漫第一页是一个动漫追更入口导航站，我们把热门作品、新番连载、主题分类等信息集中整理在首页，让你不用到处找，就能快速定位想看的内容并一键进入对应页面。',
  },
  {
    q: '如何快速找到自己想看的动漫？',
    a: '你可以在「热门作品」板块直接浏览当季热门番剧，也可以根据「主题分类」按热血、奇幻、恋爱、治愈等类型筛选，或者到「新番连载」查看最新更新的作品，入口都很清晰。',
  },
  {
    q: '收藏本站后为什么能更快进入？',
    a: '把卡通动漫第一页加入浏览器书签或收藏后，以后想追番只需打开书签即可直达首页，省去重复搜索的时间，真正做到「打开即看、追更不迷路」。',
  },
  {
    q: '打开页面加载很慢怎么办？',
    a: '建议先检查网络连接是否稳定，并尝试刷新页面。本站已做页面轻量化与加载优化，大多数情况下都能快速打开；若仍异常，可通过「联系我们」反馈你遇到的问题。',
  },
  {
    q: '想看的作品在首页找不到怎么办？',
    a: '如果你有想看的动漫却找不到对应入口，可以通过页面底部的「联系我们」反馈给我们。我们会持续完善热门作品与新番的收录，让你的追更体验越来越顺畅。',
  },
];

export const TESTIMONIALS = [
  {
    name: '追番达人·小林',
    role: '资深动漫爱好者',
    quote: '把第一页收藏后，每周追更都特别省心，新番更新时间一目了然，再也不会漏看想看的番了。',
    avatar: 'https://readdy.ai/api/search-image?query=A%20friendly%20flat%20illustration%20avatar%20of%20a%20young%20man%20with%20warm%20smile%2C%20rounded%20minimal%20style%2C%20coral%20and%20teal%20color%20palette%2C%20clean%20background&width=200&height=200&seq=avatar-01&orientation=squarish',
  },
  {
    name: '漫剪小圆',
    role: '二次元内容创作者',
    quote: '分类很全，热血、治愈、悬疑都有，找素材和灵感的时候直接在首页逛一圈，效率高了不少。',
    avatar: 'https://readdy.ai/api/search-image?query=A%20friendly%20flat%20illustration%20avatar%20of%20a%20young%20woman%20with%20cute%20short%20hair%20and%20gentle%20smile%2C%20rounded%20minimal%20style%2C%20coral%20and%20teal%20color%20palette%2C%20clean%20background&width=200&height=200&seq=avatar-02&orientation=squarish',
  },
  {
    name: '宅在家阿哲',
    role: '追番新人',
    quote: '第一次用就被「打开即看」的体验圈粉了，入口很清晰，作为刚入坑的萌新也能快速上手。',
    avatar: 'https://readdy.ai/api/search-image?query=A%20friendly%20flat%20illustration%20avatar%20of%20a%20cheerful%20young%20man%20wearing%20glasses%2C%20rounded%20minimal%20style%2C%20coral%20and%20teal%20color%20palette%2C%20clean%20background&width=200&height=200&seq=avatar-03&orientation=squarish',
  },
];

export const STATS = [
  { num: '260+', label: '热门作品' },
  { num: '8', label: '主题分类' },
  { num: '1200+', label: '新番信息' },
  { num: '24h', label: '每周更新提醒' },
];